import { render, staticRenderFns } from "./pile-datail.vue?vue&type=template&id=1c29e585&scoped=true"
import script from "./pile-datail.vue?vue&type=script&lang=js"
export * from "./pile-datail.vue?vue&type=script&lang=js"
import style0 from "./pile-datail.vue?vue&type=style&index=0&id=1c29e585&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c29e585",
  null
  
)

export default component.exports